export default {
  custom: () => import("/disk2/server/proxy-front-ssr/dists/sx/layouts/custom.vue"),
  default: () => import("/disk2/server/proxy-front-ssr/dists/sx/layouts/default.vue")
}